var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _line, _polygon, _line2, _line3, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolsmanagementinstrumente(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.022 742.804",
    enableBackground: "new 0 0 503.022 742.804",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000087383064989479875660000004554228616407937456_",
    d: "M96.402-184.795l1.535,45.85H-78.339 c0,0,2.895-8.443,2.895-22.926c0-15.227-2.895-24.116-2.895-24.116L96.402-184.795z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030487837224858523440000002285799758582476678_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087383064989479875660000004554228616407937456_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000030487837224858523440000002285799758582476678_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M64.835-367.104L-203.429-98.847 M69.219-360.968L-199.046-92.706 M75.58-356.358l-268.267,268.26 M79.962-350.22L-188.301-81.959  M86.034-345.9L-182.231-77.642 M90.418-339.765L-177.847-71.503 M96.779-335.158L-171.486-66.897 M101.162-329.019 l-268.264,268.26 M106.537-324.533L-161.726-56.271 M110.922-318.394L-157.341-50.132 M117.283-313.787L-150.979-45.525  M121.665-307.649L-146.595-39.39 M127.736-303.331L-140.526-35.07 M132.121-297.193L-136.144-28.932 M138.483-292.586 L-129.78-24.324 M142.865-286.446l-268.264,268.26 M148.611-282.496l-268.263,268.26 M152.996-276.357L-115.266-8.098  M159.358-271.751L-108.905-3.49 M163.744-265.613L-104.524,2.648 M169.812-261.295L-98.452,6.967 M174.197-255.157L-94.065,13.104  M180.559-250.548L-87.705,17.711 M184.943-244.411L-83.32,23.851 M190.317-239.922L-77.946,28.337 M194.7-233.785L-73.563,34.471  M201.06-229.179L-67.202,39.083 M205.445-223.039L-62.817,45.218 M211.515-218.72L-56.745,49.539 M215.898-212.584L-52.364,55.676  M222.265-207.976L-46.003,60.287 M226.646-201.839L-41.618,66.422"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    d: "M416.06,426.754c-19.078,74.094-94.6,118.62-168.686,99.415c-74.084-19.203-118.67-94.829-99.596-168.93 c19.084-74.104,94.589-118.6,168.686-99.408C390.549,277.03,435.141,352.658,416.06,426.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8EF93",
    d: "M157.829,469.506 M359.353,479.104 c9.8-17.409,14.286-24.193,11.368-31.199c-4.023-9.664-13.831-6.358-21.312-8.19c-1.367-0.334-2.82-0.319-4.206-0.606 c-11.905-2.485-15.772-9.487-11.978-20.926c2.451-7.383,4.738-14.862,6.357-22.456c0.449-2.101,0.361-5.493-2.962-6.914 c-3.328-1.418-34.321,1.515-21.595,34.915c5.028,13.193,8.159,14.8,6.323,19.313c-4.862,11.948-17.129,4.041-26.146-1.161 c-11.521-6.646-15.141,19.911-87.723,21.695c-11.62,0.288-24.808-20.081-18.538-29.56c9.729-14.713,17.336-28.686,37.412-36.19 c20.074-7.506,26.418-31.701,24.374-37.488c-1.775-5.038-4.28-10.442-8.036-14.045c-17.487-16.808-13.04-35.742,6.335-48.342 c11.438-7.438,15.571-8.138,34.272-4.662c18.698,3.48,39.07,8.045,37.645,31.131c-1.422,23.083,15.843,43.733,19.239,48.065 c3.396,4.332,8.43,2.584,10.364,1.059c4.669-3.679,2.395-10.7-2.457-19.003c-5.536-9.469-0.56-22.012-2.13-32.825 c-0.63-4.329-4.313-8.942-7.854-11.96c-7.703-6.556-16.803-11.529-24.201-18.376c-5.922-5.471-3.673-11.008,4.431-12.342 c3.186-0.523,7.205,0.229,10.009,1.847c14.642,8.472,31.417,12.359,41.167,29.426c3.779,6.612,17.102,14.88,20.845,12.393 c7.529-5,5.765-8.778,5.765-8.778c42.987,62.949,28.552,148.51-37.327,193.48C341.855,516.974,349.553,496.513,359.353,479.104z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    d: "M213.612,95.859c-86.676,0-156.94,70.264-156.94,156.939 c0,86.676,70.264,156.94,156.94,156.94s156.94-70.264,156.94-156.94c0-23.683-5.246-46.14-14.639-66.273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#290A3D",
    strokeWidth: 2,
    d: "M213.612,122.224c-72.114,0-130.574,58.459-130.574,130.574 c0,72.113,58.46,130.572,130.574,130.572s130.574-58.459,130.574-130.572"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    d: "M213.612,149.489c-57.057,0-103.31,46.254-103.31,103.311 c0,57.056,46.253,103.309,103.31,103.309c32.846,0,62.113-15.328,81.035-39.223"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B2A6C9",
    strokeWidth: 2,
    d: "M213.612,177.462c-41.607,0-75.337,33.729-75.337,75.337 c0,41.607,33.73,75.337,75.337,75.337s75.337-33.73,75.337-75.337c0-8.321-1.349-16.327-3.84-23.812"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M162.164,685.844c0,0,0.643-91.521-87.489-146.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M125.227,685.844c0,0-25.276-49.685-87.49-68.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M117.072,577.268c-11.033-14.303,0.933-30.686,16.572-34.123 C142.899,554.355,135.707,574.533,117.072,577.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M141.049,612.737c-11.036-14.305,0.93-30.685,16.571-34.123 C166.873,589.824,159.679,610.002,141.049,612.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M143.68,612.733c-8.634,15.411-31.6,15.647-43.4,6.401C106.73,606.629,131.009,600.996,143.68,612.733z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M118.342,576.596c-10.382,14.641-33.27,13.017-43.94,2.859C82.271,567.531,107.091,563.888,118.342,576.596 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M96.091,555.221c-19.773,4.076-34.433-10.701-33.244-24.176C78.536,527.37,99.044,539.605,96.091,555.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M45.257,619.753c-11.134,6.804-24.859,0.687-28.263-8.007C25.694,606.073,42.306,609.339,45.257,619.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M72.584,630.978c-12.308-5.203-12.014-18.196-4.287-24.677C78.295,610.205,82.353,624.058,72.584,630.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M93.629,647.248c-9.589-8.289-4.211-20.484,5.632-24.488C107.173,629.184,105.572,643.385,93.629,647.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M93.913,649.36c-4.499,10.896-19.946,12.413-28.674,6.896C68.512,647.447,84.386,642.212,93.913,649.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M70.514,631.67c-4.497,10.897-19.946,12.412-28.675,6.894C45.113,629.756,60.987,624.521,70.514,631.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8EF93",
    d: "M74.675,701.546h149.05c0,0-12.965-30.319-45.363-13.536c-35.642-22.205-69.993,4.237-69.993,4.237 S81.805,680.427,74.675,701.546z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    d: "M458.634,585.55c0,22.11-17.924,17.935-40.033,17.935l0,0c-22.11,0-40.032,4.176-40.032-17.935V468.349 c0-22.109,17.922-18.032,40.032-18.032l0,0c22.109,0,40.033-4.077,40.033,18.032V585.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.926,
    y: 470.305,
    fill: "#FFFFFF",
    width: 75.349,
    height: 112.899
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 404.957,
    y1: 460.293,
    x2: 432.243,
    y2: 460.293
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M424.733,592.909c0,3.387-2.746,6.133-6.133,6.133c-3.387,0-6.134-2.746-6.134-6.133c0-3.387,2.747-6.133,6.134-6.133 C421.987,586.776,424.733,589.522,424.733,592.909z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M396.574,681.512c0,0-0.873-128.271-0.873-140.934s-0.982-14.168-12.706-14.512c-33.231-0.977-129.665-4.887-201.665-7.167 c-10.746-0.34-13.032,1.951-13.032,14.661c0,26.063,0.326,156.706,0.326,156.706s2.596,26.611,2.596,31.481 c0,4.87,5.298,7.153,23.793,5.985c30.95-1.955,260.368-15.929,272.036-16.615c5.538-0.326,7.55-5.387-1.303-8.145 C445.873,696.781,396.574,681.512,396.574,681.512z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 167.43,
    y1: 690.048,
    x2: 397.294,
    y2: 680.599
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141456175984499929310000003817945669039899281_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.3343,
    y1: 473.1087,
    x2: 217.9319,
    y2: 694.9725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    style: {
      stopColor: "#684B93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    style: {
      stopColor: "#280A3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#1F1227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9749,
    style: {
      stopColor: "#1A171B"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000141456175984499929310000003817945669039899281_)",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 182.15,532.645 383.982,540.136 385.662,668.921 183.504,674.787 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 196.82,
    y1: 697.274,
    x2: 394.077,
    y2: 689.373
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 197.876,
    y1: 704.246,
    x2: 403.643,
    y2: 694.318
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M359.163,554.226c0,0,3.762-5.34,8.637-5.34 s6.121,6.432,12.137,6.432c6.018,0,7.678-6.432,12.553-6.432s7.262,6.432,12.447,6.432c5.188,0,7.365-6.432,12.24-6.432 s6.949,6.432,12.24,6.432c5.291,0,6.742-6.432,12.656-6.432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M334.71,568.905c0,0,3.761-5.34,8.636-5.34 s6.121,6.432,12.137,6.432c6.016,0,7.676-6.432,12.553-6.432c4.875,0,7.26,6.432,12.447,6.432s7.365-6.432,12.24-6.432 c4.877,0,6.951,6.432,12.24,6.432c5.291,0,6.744-6.432,12.656-6.432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M334.71,582.887c0,0,3.761-5.34,8.636-5.34 s6.121,6.432,12.137,6.432c6.016,0,7.676-6.432,12.553-6.432c4.875,0,7.26,6.432,12.447,6.432s7.365-6.432,12.24-6.432 c4.877,0,6.951,6.432,12.24,6.432c5.291,0,6.744-6.432,12.656-6.432"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.445,
    y: 52.855,
    transform: "matrix(0.2651 0.9642 -0.9642 0.2651 292.6541 -212.1499)",
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 66.11,
    height: 66.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.559,
    y: 27.806,
    transform: "matrix(0.2651 0.9642 -0.9642 0.2651 276.9366 -244.1921)",
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 64.205,
    height: 63.545
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 325.78,109.118 308.255,45.373 320.888,20.174 337.907,82.082  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 320.888,20.174 259.243,37.122 244.694,62.703  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 276.536,
    y1: 98.955,
    x2: 262.39,
    y2: 126.545
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsmanagementinstrumente);
export default __webpack_public_path__ + "static/media/toolsmanagementinstrumente.9cbedce54f456f7460e0a143150eec41.svg";
export { ForwardRef as ReactComponent };